export enum PaymentStatus {
  pending = 'Por vencer',
  expired = 'Vencido',
  paid = 'Pagado'
}

export enum PaymentType {
  MATRICULA = '01',
  PENSIONES = '02',
  ADMINISION = '03',
  SEGUROS = '05',
  TRAMITES = '08'
}
